(function(root){
 'use strict';
 let data={products:{},components:{}};
 const calculated=new Map();
 const escape=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const money=n=>new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}).format(n);
 function configure(value){data=value||{products:{},components:{}};calculated.clear()}
 function get(p,variant){const handle=typeof p==='string'?p:p.handle,entry=data.products[handle];return entry?.variants?.[String(variant?.id||variant||p.variant)]||entry?.default||calculated.get(handle)||null}
 function component(code){return data.components[code]||data.components[data.aliases?.[code]]||null}
 function compose(rows){
  if(!rows?.some(x=>x.key==='Stangen')||!rows.some(x=>x.key==='Voeten'))return null;
  const parts=[];
  for(const row of rows){
   const codes=row.value.match(/\b\d{4,6}\b/g)||[];if(!codes.length)return null;
   for(const code of codes){const part=component(code);if(!part||!part.amount||part.currency!=='EUR')return null;parts.push({...part,code,key:row.key})}
  }
  // Each bar occurrence represents one supplier pack. Edge has two single bars;
  // SquareBar/WingBar Evo have one two-bar pack. Do not guess missing quantities.
  const bars=parts.filter(x=>x.key==='Stangen');
  if(bars.reduce((sum,x)=>sum+(x.barCount||0),0)!==2)return null;
  const feet=parts.filter(x=>x.key==='Voeten'),kits=parts.filter(x=>x.key==='Kitset');
  if(feet.length!==1||kits.length>1)return null;
  if(feet[0].requiresKit===true&&kits.length!==1)return null;
  if(feet[0].requiresKit===false&&kits.length!==0)return null;
  return {amount:parts.reduce((sum,x)=>sum+Math.round(x.amount*100),0)/100,currency:'EUR',label:'Adviesprijs set',basis:'Som van de adviesprijzen van de meegeleverde Thule-onderdelen.',sources:[...new Set(parts.flatMap(x=>x.sources||[]))],checkedAt:data.checkedAt,components:parts.map(x=>({code:x.code,amount:x.amount}))};
 }
 function content(record,selling,quantity=1){
  if(!record||record.currency!=='EUR'||!(record.amount>0))return '';
  const total=Math.round(record.amount*quantity*100)/100;
  if(Math.round(Number(selling)*100)>Math.round(total*100))return '';
  const label=(record.label||'Adviesprijs')+(quantity>1?' ('+quantity+' st.)':'');
  const explanation=[record.basis,'Gecontroleerd op '+record.checkedAt].filter(Boolean).join(' ');
  const amount=total>Number(selling)?'<del>'+money(total)+'</del>':'<span>'+money(total)+'</span>';
  return '<span class="reference-label" title="'+escape(explanation)+'">'+escape(label)+'</span> '+amount;
 }
 function markup(p,variant,selling,quantity=1){
  const handle=typeof p==='string'?p:p.handle,id=variant?.id||variant||p.variant||'';
  const record=get(p,id);
  // Known prices are already complete. Only unresolved rack sets need the lazy
  // observer metadata; repeating it on every static card bloats the site archive.
  if(record){const html=content(record,selling,quantity);return html?'<span class="reference-price">'+html+'</span>':'';}
  if(!record&&!root.DSet.eligible(handle))return '';
  return '<span class="reference-price" data-reference-handle="'+escape(handle)+'" data-reference-variant="'+escape(id)+'" data-reference-selling="'+Number(selling)+'" data-reference-quantity="'+quantity+'" aria-live="polite">'+content(record,selling,quantity)+'</span>';
 }
 function discount(p){const r=get(p);return r&&r.amount>Number(p.price)?Math.floor((1-Number(p.price)/r.amount)*100):0}
 async function fill(node){
  const handle=node.dataset.referenceHandle;
  let record=get(handle,node.dataset.referenceVariant);
  if(!record&&root.DSet.eligible(handle))try{record=compose(await root.DSet.load(handle));if(record)calculated.set(handle,record)}catch{}
  if(node.isConnected)node.innerHTML=content(record,Number(node.dataset.referenceSelling),Number(node.dataset.referenceQuantity)||1);
 }
 function observe(){
  const observer=new IntersectionObserver(entries=>{for(const e of entries)if(e.isIntersecting){observer.unobserve(e.target);fill(e.target)}},{rootMargin:'120px'});
  const scan=()=>document.querySelectorAll('[data-reference-handle]:not([data-reference-observed])').forEach(node=>{node.dataset.referenceObserved='true';observer.observe(node)});
  new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});scan();
 }
 root.DPrice={configure,get,component,compose,content,markup,discount,observe};
 if(typeof module!=='undefined')module.exports=root.DPrice;
})(typeof globalThis!=='undefined'?globalThis:this);
